/**
 * Canonical API path constants for the Django/allauth endpoints.
 *
 * *Upstream* paths are relative to the Django API base (used inside route.ts and
 * djangoFetchJson).  *Proxy* paths include the /api/django prefix and are used by
 * client-side fetch calls that go through the Next.js proxy route.
 */

// allauth upstream paths (no /api/django prefix — used in route.ts)
export const ALLAUTH_LOGIN_UPSTREAM = "_allauth/browser/v1/auth/login";
export const ALLAUTH_SIGNUP_UPSTREAM = "_allauth/browser/v1/auth/signup";
const ALLAUTH_SESSION_UPSTREAM = "_allauth/browser/v1/auth/session";
const ALLAUTH_PASSWORD_REQUEST_UPSTREAM = "_allauth/browser/v1/auth/password/request";
const ALLAUTH_PASSWORD_RESET_UPSTREAM = "_allauth/browser/v1/auth/password/reset";
export const ALLAUTH_VERIFY_EMAIL_UPSTREAM = "_allauth/browser/v1/auth/email/verify";
const ALLAUTH_RESEND_VERIFY_EMAIL_UPSTREAM =
  "_allauth/browser/v1/auth/email/verify/resend";

// allauth proxy paths (full /api/django/... — used by client-side fetches)
export const ALLAUTH_LOGIN_PROXY = `/api/django/${ALLAUTH_LOGIN_UPSTREAM}`;
export const ALLAUTH_SIGNUP_PROXY = `/api/django/${ALLAUTH_SIGNUP_UPSTREAM}`;
export const ALLAUTH_SESSION_PROXY = `/api/django/${ALLAUTH_SESSION_UPSTREAM}`;
export const ALLAUTH_PASSWORD_REQUEST_PROXY = `/api/django/${ALLAUTH_PASSWORD_REQUEST_UPSTREAM}`;
export const ALLAUTH_PASSWORD_RESET_PROXY = `/api/django/${ALLAUTH_PASSWORD_RESET_UPSTREAM}`;
export const ALLAUTH_VERIFY_EMAIL_PROXY = `/api/django/${ALLAUTH_VERIFY_EMAIL_UPSTREAM}`;
export const ALLAUTH_RESEND_VERIFY_EMAIL_PROXY = `/api/django/${ALLAUTH_RESEND_VERIFY_EMAIL_UPSTREAM}`;

export type StepKey = "weight_priorities" | "constraints";

/**
 * Prepend the Next.js proxy prefix to an upstream Django path.
 * E.g. proxyPath("v1/questionnaires") → "/api/django/v1/questionnaires"
 */
export function proxyPath(path: string): string {
  const p = path.replace(/^\/+/, "");
  return `/api/django/${p}`;
}
